import { render, staticRenderFns } from "./TableEditWidget.vue?vue&type=template&id=1abb4259&"
import script from "./TableEditWidget.vue?vue&type=script&lang=ts&"
export * from "./TableEditWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports